var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-over"}),_vm._v(" "),_c('div',[(_vm.isReload)?_c('HeadBar',{staticClass:"header-class"}):_vm._e(),_vm._v(" "),(_vm.isReload)?_c('AppMain',{staticClass:"app-class",style:({'height':'calc('+(_vm.height - 112)+'px)'})}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4abbfe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layoutCollege/layout.vue
// module id = null
// module chunks = 